import React from 'react';
import { useHistory } from 'react-router-dom';
import { Media, Button } from 'reactstrap';

function GoodsDetails(props) {

    let history = useHistory();

    var goods = history.location.state;

    return (
        <React.Fragment>
            {
                goods && goods.map((goodsItem, index) =>
                    <Media key={`media_${index}`}>
                        <Media body>
                            <Media heading>
                                {`${goodsItem.pieces || ''} x ${goodsItem.type || ''} `}
                                { goodsItem.dg_class && ` (DG ${goodsItem.dg_class})`}
                            </Media>
                            <p>
                                {`${goodsItem.description || ''} ${(goodsItem.weight && goodsItem.weight.toFixed(1)) || ''} kg, ${goodsItem.volume && goodsItem.volume.toFixed(3)} m`}
                                <sup>3</sup>
                            </p>
                        </Media>
                    </Media>
                )
            }
            <Button color="primary" onClick={e => history.goBack()} block>Back</Button>
        </React.Fragment>
        );
}

export { GoodsDetails };